module.exports = __webpack_public_path__ + "static/nova-4a75aea5dcb3624f0db16700f7287969.svg";